import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

const primaryMembershipSelector = createSelector(
  get(['auth', 'memberships']),
  (memberships) => memberships.find((m) => m.primary),
);

export default primaryMembershipSelector;
